/**
 * this gets called in two situations:
 * 1- on new QT rendering time: to disable input if no option is mapped and vice versa
 * 2- on an option selection: to disable if the selected option is mapped and vice versa
 * @param {any} msg
 * @param {any} selection
 */
const isQTMessageMapped = (msg, selection) => {
    if (!msg) {
        return false;
    }
    // server sends either "" or "[]" when no options
    if (msg.options && msg.options !== '[]') {
        // if message has options, we can validate on option selection as well as on rendering time
        msg.options = ApexChat.TryParse(msg.options);
        if (msg.options.find) {
            const foundMapping = msg.options.find((opt) => {
                if (selection) {
                    // on option selection
                    return (
                        opt.nextQuestionId > 0 &&
                        opt.text === selection &&
                        opt.nextQuestionText != null
                    );
                }
                // on rendering time
                return opt.nextQuestionId > 0 && opt.nextQuestionText != null;
            });
            return foundMapping != null;
        }
        return msg.isNextQuestionMapped;
    }
    // fallback for those scenarios when options are null;
    // on rendering time, we can just use the flag
    return msg.isNextQuestionMapped;
};
export default isQTMessageMapped;
